// Copyright (c) 2019 Deere & Company

import actions from '../../action-list';

export const updateGoodsInstallationVat = (goodsInstallationVatOptions, optionSelected) => {

    const defaultOption = {
        key: '',
        value: ''
    };

    const goodsInstallationVat = optionSelected ?
        goodsInstallationVatOptions.find(option => option.key === optionSelected) :
        defaultOption;

    return {
        goodsInstallationVat,
        type: actions.UPDATE_CLAIM_WEAR_PARTS_GOODS_INSTALLATION_VAT
    };

};



// WEBPACK FOOTER //
// ./src/claim/wear-parts/action-creators/update-goods-installation-vat.js